module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_ENSEIGNES_LE_BOUCHER_SCRABBLE.a6366fdf.png";